import {getCurrentInstance} from 'vue'

function base64DecodeUnicode(str) {
  return decodeURIComponent(
    Array.prototype.map.call(
      window.atob(str),
      function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }
    ).join('')
  )
}

export const useInlineTemplateCompiler = (test = null) => {
  const instance = getCurrentInstance()

  const template = base64DecodeUnicode(test || instance.attrs['component-template'])

  delete instance.type.render
  instance.type.template = template
}
